import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BULK_IMPORT_META_DATA } from '@reporting/views/bulk-import/bulk-import-config';
import { File } from 'app/models/common/file.model';
import { FileHelperService } from 'app/services/file-helper.service';
import { NotifyService } from 'app/services/notify.service';

@Component({
    templateUrl: './bulk-import-results.view.html',
    styleUrls: ['./bulk-import-results.style.scss'],
})
export class BulkImportResultsView implements OnInit {
    isLoading = true;
    entity;
    readonly importMetaData = BULK_IMPORT_META_DATA;
    fileId: number;
    processing = false;
    file: File;

    constructor(
        private route: ActivatedRoute,
        private notify: NotifyService,
        private fileHelper: FileHelperService,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.setEntityFromRoute();

        File.find(this.fileId)
            .then((file) => {
                this.file = file;
                this.isLoading = false;
            })
            .catch(() => this.notify.error('Results not found'));
    }

    download(): void {
        return this.fileHelper.save(this.file.id, this.file.filename, 'csv');
    }

    private setEntityFromRoute(): void {
        this.fileId = Number(this.route.snapshot.params['file_id']);

        this.entity = this.importMetaData.find((entity) =>
            entity.routerLink.includes(this.activatedRoute.snapshot.params.entity)
        );

        // Added an extra condition because BE Blade template using camel case for past bad data emails.
        if (!this.entity && this.entity !== 'timeOffRequests') {
            this.notifyError();
            return;
        }
    }

    private notifyError(): void {
        this.notify.error('Could not find the results data.');
    }
}
